import './dropdown';
import './splide';
import './popup';

document.addEventListener('DOMContentLoaded', () => {
    const hasElement = document.querySelectorAll<HTMLElement>("[data-progress]").length > 0;
    const innerWidth = window.innerWidth;
    if(!hasElement) {
        return;
    }

    if(innerWidth < 992) {
        console.info("Gsap initialisation skipped, window too small");
        return;
    }

    import('./animations.ts');
});